var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center bg-gray-200 rounded-full px-4 py-2",class:{
    'bg-blue bg-secondary text-white': _vm.value,
    'text-blue text-secondary': !_vm.value,
    'opacity-50': _vm.disabled && !_vm.value,
    'cursor-pointer': !_vm.disabled && !_vm.value
  },on:{"click":_vm.click}},[(_vm.icon)?_c('icon',{staticClass:"pr-2",class:{ 'text-white': _vm.value, 'text-blue text-secondary': !_vm.value },attrs:{"name":_vm.icon}}):_vm._e(),_c('div',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }